module.exports = __webpack_public_path__ + "static/revival3-f88504943191b458afcdf99b69f483a2.jpg";